"use client";

import dynamic from "next/dynamic";

const TrustpilotWidget = dynamic(() => import("@/components/common/TrustpilotWidget"), {
  ssr: false
});

export default function TrustpilotWidgetClient({ bgColor }) {
  return (
    <div
      style={{
        minHeight: "45px",
        width: "100%"
      }}
    >
      <TrustpilotWidget bgColor={bgColor} />
    </div>
  );
}
